import React from 'react';

import { Card, CardContent, CardHeader } from '~/shadcn/components/ui/Card';
import { Skeleton } from '~/shadcn/components/ui/Skeleton';

/**
 * RouteCardSkeleton
 *
 * Loading placeholder for a RouteCard. Matches the visual structure
 * of a RouteCard with shimmer placeholders for each content area.
 */
function RouteCardSkeleton() {
    return (
        <Card>
            <CardHeader className="pb-2">
                <Skeleton className="h-5 w-16" />
                <Skeleton className="h-6 w-12 mt-2" />
                <Skeleton className="h-4 w-20" />
            </CardHeader>
            <CardContent className="space-y-3">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-48" />
                <Skeleton className="h-2 w-full" />
                <div className="grid grid-cols-3 gap-2">
                    <Skeleton className="h-8" />
                    <Skeleton className="h-8" />
                    <Skeleton className="h-8" />
                </div>
            </CardContent>
        </Card>
    );
}

export default RouteCardSkeleton;
